import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BlogsService {
  apiPrefix: string;
  headers = new HttpHeaders();

  constructor(private http: HttpClient) {
    this.apiPrefix = environment.baseUrl + 'api/v1/blog/';
    this.headers = this.headers.set(
      'x-access-token',
      localStorage.getItem('adventouresAdminAuthToken')
    );
  }

  createBlog(params) {
    return this.http.post(this.apiPrefix + 'create', params, {
      headers: this.headers,
    });
  }

  updateBlog(params) {
    return this.http.post(this.apiPrefix + 'update', params, {
      headers: this.headers,
    });
  }

  deleteBlog(params) {
    return this.http.post(this.apiPrefix + 'delete', params, {
      headers: this.headers,
    });
  }

  getBlogList(params) {
    return this.http.post(this.apiPrefix + 'list', params, {
      headers: this.headers,
    });
  }
}
